<template>
  <div>
    <v-data-table
      :search="search"
      :loading="loading"
      :headers="headers"
      :items="redirects"
    >
      <template v-slot:item.actions="{ item }">
        <gg-btn @click="openModal('delete', item)">
          Delete
        </gg-btn>
      </template>
    </v-data-table>
    <delete-redirect-modal
      :opened="modals.delete"
      :redirect="selectedItem"
      @redirect-deleted="loadData"
      @close="closeModal('delete')"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import modalsTable from '@/mixins/modalsTable'
import DeleteRedirectModal from './DeleteRedirectModal'

export default {
  name: 'RedirectsTable',
  components: { DeleteRedirectModal },
  mixins: [modalsTable],
  props: {
    search: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      headers: [
        {
          text: 'Domain',
          value: 'domain'
        },
        {
          text: 'Type',
          value: 'type'
        },
        {
          text: 'Redirect url',
          value: 'destination'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'center',
          sortable: false
        }
      ],
      modals: {
        delete: false,
      },
    }
  },
  computed: mapGetters({
    redirects: 'hostingDomains/redirects',
    pagination: 'pagination'
  }),
  methods: {
    ...mapActions({
      getHostingRedirects: 'hostingDomains/getHostingRedirects',
      reportError: 'reportError'
    }),
    async loadData () {
      this.loading = true
      try {
        await this.getHostingRedirects(this.$route.query.user)
        this.loading = false
        this.$emit('table-reloaded')
      } catch (e) {
        this.reportError(e)
        this.loading = false
      }
    }
  },
  created () {
    this.loadData()
  }
}
</script>
